import React from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from '@chakra-ui/react';
import { KDrawerProps } from './KDrawer.types';
import { getVariantStyles } from './KDrawer.styles';
import { KDrawerHeader } from './components/KDrawerHeader';
import { KDrawerFooter } from './components/KDrawerFooter';
import { ModalCloseButton } from '@/ui/ModalClosebutton';

export const KDrawer: React.FC<
  KDrawerProps & { handleOutsideClose?: () => void }
> = ({
  isOpen,
  onClose,
  header,
  body,
  footer,
  KDrawerHeaderProps,
  KDrawerFooterProps,
  headerProps = {},
  bodyProps = {},
  footerProps = {},
  contentProps = {},
  variant = 'default',
  showCloseButton = true,
  showOverlay = true,
  skipFooter = false,
  skipHeader = false,
  children,
  handleOutsideClose = () => ({}),
  ...rest
}) => {
  const styles = getVariantStyles(variant);

  return (
    <Drawer isOpen={isOpen} onClose={handleOutsideClose} {...rest}>
      {showOverlay && <DrawerOverlay zIndex="1400" />}
      <DrawerContent
        className="k-drawer-content"
        data-test-id="k-drawer-content"
        {...styles.content}
        {...contentProps}
      >
        {showCloseButton && <ModalCloseButton onClose={onClose} />}

        {!skipHeader &&
          (React.isValidElement(header) ? (
            header
          ) : (
            <DrawerHeader {...styles.header} {...headerProps}>
              <KDrawerHeader {...KDrawerHeaderProps} />
            </DrawerHeader>
          ))}

        <DrawerBody p="0" m="0" {...styles.body} {...bodyProps}>
          {children}
        </DrawerBody>

        {!skipFooter &&
          (React.isValidElement(footer) ? (
            footer
          ) : (
            <DrawerFooter {...styles.footer} {...footerProps}>
              <KDrawerFooter {...KDrawerFooterProps} />
            </DrawerFooter>
          ))}
      </DrawerContent>
    </Drawer>
  );
};
